import { EntityType } from '../../../@types/entityTypes';
import workspaceQuery from '../../queries/sales/ConsolidatedPickWorkspaceQuery.graphql';
import instanceQuery from '../../queries/sales/ConsolidatedPickQuery.graphql';
import { workspaceActionsForPermissions } from '../../../actions/sales/ConsolidatedPickWorkspaceAction';
import { ReportType } from '../../schema/p4types';

const ConsolidatedPick: EntityType = {
  type: 'ConsolidatedPick',
  title: 'Consolidated Pick',
  formTitle: 'Consolidated Pick',
  formUrl: '/Sales/Picking/ConsolidatedPick/Details/',
  workspaceUrl: '/Sales/Picking/ConsolidatedPick/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  screenReference: 'CONSOLIDATED_PICK',
  actions: [...workspaceActionsForPermissions],
  configuration: {
    title: 'Consolidated Picks',
    reportType: ReportType.ConsolidatedPick,
  },
};

export default ConsolidatedPick;
